
  <div class="filter-container">
    <form [formGroup]="byDepartmentForm">
      <div formArrayName="departments">
        <div
          class="sgc"
          *ngFor="let departmentCtrl of departments.controls; let i = index"
        >
          <single-choice
            [formControl]="departmentCtrl"
            (click)="setEditingIndex(i)"
            [completedUrl]="completionUrl"
            [topic]="'departments'"
            [editMode]="true"
            [ticketId]="fakeId"
            [icon]="'apartment'"
            (choiceEvent)="relaySingleChoice($event)"
            [labelOnDemand]="departmentLabelerByService"
            [choiceObserver]="departmentObserver"
          ></single-choice>
        </div>
      </div>

      <button
        type="button"
        class="add-department-btn"
        (click)="addDepartmentField()"
      >
        +
      </button>

      <not
        [filter]="byDepartmentFilter"
        (filterChanged)="onFilterChanged($event)"
      >
      </not>

      <button class="apply-filter-btn" type="submit" (click)="apply()">
        Apply
      </button>
    </form>
  </div>

